export const commentsStyles = {
	dialog: {
		'& .MuiDialog-paper': {
			backgroundColor: '#171718',
			'& .MuiDialogTitle-root': {
				fontFamily: 'Arial',
				fontSize: '16px',
				color: 'white'
			}
		}
	}
};
